/* eslint-disable eqeqeq */
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import { AxiosError } from "axios";
import Button from "components/button";
import Input from "components/input";
import Radio from "components/radio";
import { LoaderContext } from "contexts/loader-context";
import { useContext } from "react";
import { useForm } from "react-hook-form";
import formServices from "services/form-builder-services";
import ProfileService from "services/profile-services";
import { Label } from "theme/theme";

function StepOne({ state, handleChange, nextStep, session, setHelper, prevStep, setError }: any) {
  const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(["curp", "street1", "streetType", "streetNumber", "apartament", "postalCode"])) })
  const { setLoad } = useContext(LoaderContext)


  async function onFormSubmit(data: any) {
    handleChange(data)
    setLoad(true)
    try {
      const response = await ProfileService.checkZip({ postalCode: data.postalCode }, { session })
      handleChange({ city: response.data[0].cities[0].id, state: response.data[0].id })
      setHelper({ city: response.data[0].cities[0], state: response.data[0], neighborhood: response.data[0].cities[0].neighborhoods })
      nextStep()
    } catch (err) {
      const typedError = err as AxiosError
      const { code } = typedError.response?.data || {}
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  return (
    <div className="flex flex-col flex-1 md:pt-10">
      <form className="flex h-full justify-between flex-col gap-4 mx-7 mb-7" onSubmit={handleSubmit(onFormSubmit)} noValidate>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">CURP {THEME_CONFIG.notAvailableFields.includes('curp') && '(OPCIONAL)'}</Label>
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder="Tu documento de identidad (CURP)"
              name="curp"
              defaultValue={state?.curp}
              {...register("curp")}
            />
            <ErrorMessage errors={errors} name="curp" />
          </div>
          <div className="gap-2 flex flex-col">
            <Label className="text-start text-2xl font-bold uppercase">¿Tu dirección?</Label>
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder="Calle"
              name="street1"
              defaultValue={state?.street1}
              {...register("street1")}
            />
            <ErrorMessage errors={errors} name="street1" />
          </div>
          <div className="flex items-center justify-evenly gap-3">
            <Radio type="radio" value="1" {...register("streetType")} defaultChecked={state.streetType == 1}>
              Calle
            </Radio>
            <Radio type="radio" value="2" {...register("streetType")} defaultChecked={state.streetType == 2}>
              Avenida
            </Radio>
            <Radio type="radio" value="3" {...register("streetType")} defaultChecked={state.streetType == 3}>
              Cerrada
            </Radio>
          </div>
          <ErrorMessage errors={errors} name="streetType" />
          <div className="flex flex-wrap items-center justify-between">
            <div className="gap-2 flex flex-col" style={{ width: '48%' }}>
              <Input
                className="text-center saira font-bold text-sm"
                type="text"
                placeholder="Número"
                name="streetNumber"
                defaultValue={state?.streetNumber}
                {...register("streetNumber")}
              />
            </div>
            <div className="gap-2 flex flex-col" style={{ width: '48%' }}>
              <Input
                className="text-center saira font-bold text-sm"
                type="text"
                placeholder="Apartamento"
                name="apartament"
                defaultValue={state?.apartament}
                {...register("apartament")}
              />
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-between">
            <div className="gap-2 flex flex-col" style={{ width: '48%' }}>
              <ErrorMessage errors={errors} name="streetNumber" />
            </div>
            <div className="gap-2 flex flex-col" style={{ width: '48%' }}>
              <ErrorMessage errors={errors} name="apartament" />
            </div>
          </div>
          <div className="gap-2 flex flex-col">
            <Input
              className="text-center saira font-bold text-sm"
              type="text"
              placeholder="CP - Código postal"
              name="postalCode"
              defaultValue={state?.postalCode}
              {...register("postalCode")}
            />
            <ErrorMessage errors={errors} name="postalCode" />
          </div>
        </div>
        <Button>
          <p className="uppercase">Siguiente</p>
        </Button>
        <button type="button" className="cursor-pointer" onClick={() => {
          prevStep()
          gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'MODIFICAR DIRECCION - Volver atras', value: '10' })
        }}>
          <p
            className={`din text-center mt-3 hover:text-red-100 uppercase underline`}
            style={{ fontSize: 10 }}
          >
            VOLVER
          </p>
        </button>
      </form>
    </div>
  )
}

export default StepOne;